import { UpgradeAssessment, UpgradeStage } from 'api/models';

export const UPGRADE_ASSESSMENT_EKS_131: UpgradeAssessment = {
  id: 'upgrasses_2e6323a4-576b-4d32-99da-70204ee00981',
  name: 'assessment-eks-131-usw1-prod-1.31-1.32',
  status: 'ready',
  deployment_strategy: 'in-place',
  environment: 'Prod',
  current_version: '1.31',
  desired_version: '1.32',
  resources: { clusters: [{ id: 'id-eks-131-usw1-prod' }] },
  requested_by: {
    id: 'usr_w12123',
    name: 'Katy Smith',
    picture: '',
  },
  created: new Date(2025, 11, 9).getTime(), // December 9, 2025
  header: {
    items: [
      {
        title: 'Cluster Name (Chkk)',
        value: 'eks-131-usw1-prod',
      },
      {
        title: 'Current',
        value: '1.31',
      },
      {
        title: 'Recommended',
        value: '1.32',
      },
      {
        title: 'Provider',
        value: 'EKS',
      },
      {
        title: 'Region',
        value: 'us-west-1',
      },
      {
        title: 'Node Groups',
        value: '6',
      },
      {
        title: 'Nodes',
        value: '83',
      },
      {
        title: 'Blueprint',
        value: 'In-Place',
      },
      {
        title: 'Projects',
        value: '25',
      },
    ],
  },
  exports: [
    {
      format: 'pdf',
      url: '/assessment-eks-131.pdf',
    },
    {
      format: 'markdown',
      url: '/assessment-eks-131.md',
    },
  ],
};

export const UPGRADE_ASSESSMENT_EKS_131_STAGES: UpgradeStage[] = [
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Control Plane \u0026 Application Changes',
    stage_number: 1,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'K8s',
              },
              {
                title: 'Current',
              },
              {
                title: 'Recommended',
              },
            ],
            data: [
              [
                {
                  value: 'Control Plane',
                },
                {
                  value: '1.31',
                },
                {
                  value: '1.32',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Infrastructure Changes',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Namespace',
              },
              {
                title: 'Kind',
              },
              {
                info_text: 'The API currently used by the resource',
                title: 'Current Version',
              },
              {
                info_text:
                  'The K8s version which stopped serving the currently used API',
                title: 'Removed In',
              },
              {
                info_text:
                  'The APIs offered as a recommended replacement to the currently used API',
                title: 'Recommended Versions',
              },
            ],
            data: [
              [
                {
                  value: 'backend-api-1',
                },
                {
                  value: 'default',
                },
                {
                  value: 'FlowSchema',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1beta3',
                },
                {
                  value: '1.32',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1',
                },
              ],
              [
                {
                  value: 'frontend-api-1',
                },
                {
                  value: 'default',
                },
                {
                  value: 'FlowSchema',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1beta3',
                },
                {
                  value: '1.32',
                },
                {
                  value: 'flowcontrol.apiserver.k8s.io/v1',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Deprecations \u0026 Removals',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Application',
              },
              {
                title: 'Namespace',
              },
              {
                title: 'Resource',
              },
              {
                title: 'Current Allowed Disruptions',
              },
            ],
            data: [
              [
                {
                  value: 'media-app-backend',
                },
                {
                  value: 'media',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'login-app-1',
                },
                {
                  value: 'auth',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'login-app1',
                },
                {
                  value: 'auth',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'login-app2',
                },
                {
                  value: 'auth',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'login-app3',
                },
                {
                  value: 'auth',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'media-app-frontend',
                },
                {
                  value: 'media',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'plat-api',
                },
                {
                  value: 'platform',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'plat-db',
                },
                {
                  value: 'platform',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
              [
                {
                  value: 'stream-svc-1',
                },
                {
                  value: 'media',
                },
                {
                  value: 'PodDisruptionBudget',
                },
                {
                  value: '0',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Misconfigured Pod Disruption Budgets (PDBs)',
        owner: 'chkk',
        status: 'active',
        step_number: 3,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Project Changes',
    stage_number: 2,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Namespace(s)',
              },
              {
                title: 'Current',
              },
              {
                title: 'Upgrade',
              },
              {
                info_text:
                  'Suggested versions do not go through Preverification. Request an Upgrade Templates for Preverified Version Recommendations. Learn more: https://docs.chkk.io/features/upgrade-preverification#upgrade-preverification',
                title: 'Suggested',
              },
              {
                info_text:
                  'Will the current remain compatible with the next Kubernetes version after the cluster is upgraded?',
                title: 'K8s Compatibility',
              },
              {
                info_text:
                  'Is the current version supported by its upstream community, cloud or vendor?',
                title: 'Supported',
              },
              {
                info_text: 'Is the current version younger than 2 years?',
                title: 'Age \u003c 2yr',
              },
              {
                info_text:
                  'Use the feedback buttons to indicate whether you agree or disagree with this upgrade suggestion.',
                render_in: {
                  cli: false,
                  markdown: false,
                  web: true,
                },
                title: 'Give Feedback',
              },
              {
                render_in: {
                  cli: false,
                  markdown: false,
                  web: true,
                },
                title: 'Actions',
              },
            ],
            data: [
              [
                {
                  value: 'Cluster Autoscaler',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.31.0',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '1.32.0',
                },
                {
                  icon: {
                    tooltip:
                      'The current autoscaler minor does not match Kubernetes 1.32, so it will not work after the upgrade.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      'Cluster Autoscaler 1.31 is no longer supported once the cluster moves beyond Kubernetes 1.31.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_13f538f7-10f3-4c5e-82a1-488b98401e60',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'AWS Load Balancer Controller',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '2.14.0',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: '2.16.0',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      'Version 2.14.0 no longer receives security or bug-fix updates under the project’s support policy.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_29177308-3960-4628-9e5d-8c25a8c24f59',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Vault Side Kick',
                },
                {
                  value: 'vault-sidekick-1',
                },
                {
                  value: '0.3.9',
                },
                {
                  badges: [
                    {
                      text: 'Optional',
                      variant: 'neutral',
                    },
                  ],
                  value: '',
                },
                {
                  value: '0.3.19',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      '0.3.9 was released in 2018, making it more than 24 months old.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_ed220598-f387-4cdc-9057-bb2f82e613ae',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Projects Marked for Upgrade',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Current Version',
              },
              {
                title: 'Namespaces',
              },
              {
                title: 'Reasons',
              },
              {
                info_text:
                  'Use the feedback buttons to indicate whether you agree or disagree with this upgrade suggestion.',
                title: 'Give Feedback',
              },
            ],
            data: [
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'Amazon EBS CSI Driver',
                },
                {
                  value: '1.51.0',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'The project documents 1.51.0 as compatible with Kubernetes 1.32 on EKS. Version 1.51.0 is inside the project’s N,N-1 support window, so it has not reached end-of-life. The release was published in October 2025, well within the 24-month freshness window.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'AWS Network Policy Agent',
                },
                {
                  value: '1.2.5-eksbuild.1',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'The current release is not classified as end-of-life in Chkk Knowledge Graph. The release was published less than 24 months ago.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Calico Operator',
                },
                {
                  value: '1.38.4',
                },
                {
                  value: 'tigera-operator',
                },
                {
                  value:
                    'No known incompatibility between version 1.38.4 and Kubernetes 1.32. No evidence that version 1.38.4 has reached end-of-life. Version 1.38.4 was published less than 24 months ago.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'CoreDNS',
                },
                {
                  value: '1.11.4-eksbuild.24',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'AWS documentation lists CoreDNS 1.11.4 as compatible with EKS 1.32. CoreDNS publishes no end-of-life notice for 1.11.4, so it is assumed still supported. The release was published in November 2024, which is within the last 24 months.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'CSI external-attacher',
                },
                {
                  value: '4.9.0-eksbuild.4',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'The release is listed as compatible with Kubernetes 1.32 in the project’s version matrix. The release is still inside the project’s stated support period and is not end-of-life. The release was published in June 2025, well within the 24-month freshness window.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'CSI external-provisioner',
                },
                {
                  value: '5.3.0-eksbuild.4',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'Documentation lists this version as compatible with Kubernetes 1.32. This version is still within the official one-year support window. The release is only six months old, well within the 24-month freshness window.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'CSI external-resizer',
                },
                {
                  value: '1.14.0-eksbuild.4',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'Chkk Knowledge Graph confirms 1.14.0 works with Kubernetes 1.32. Version 1.14.0 is still inside the CSI projecta\u0019s one-year support window. 1.14.0 was published less than 24 months ago, so it is not outdated.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'CSI external-snapshotter',
                },
                {
                  value: '8.3.0-eksbuild.2',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'This release is confirmed compatible with Kubernetes 1.32. Version 8.3.0 is still inside the CSI project’s stated support window. 8.3.0 was published within the last two years.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'CSI Livenessprobe',
                },
                {
                  value: '2.16.0-eksbuild.5',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'The current release is declared compatible with Kubernetes 1.32. The current release is still within the project’s stated support window. The current release was published less than twenty-four months ago.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  badges: [
                    {
                      text: 'Managed by: AWS',
                      tooltip:
                        'This add-on is managed by AWS, but you are responsible for upgrading it. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks. ',
                      variant: 'neutral',
                    },
                  ],
                  value: 'CSI node-driver-registrar',
                },
                {
                  value: '2.14.0-eksbuild.5',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'Release 2.14.0 supports Kubernetes 1.32 per project’s compatibility matrix. The release is still within the upstream CSI support window. The release is under 24 months old and not considered outdated.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
              [
                {
                  value: 'Kubernetes Metrics Server',
                },
                {
                  value: '0.7.0',
                },
                {
                  value: 'kube-system',
                },
                {
                  value:
                    'Version 0.7.0 satisfies the project’s Kubernetes version requirements and should operate on Kubernetes 1.32. The project does not publish a support policy, therefore we cannot confirm this version is end-of-life. Version 0.7.0 was released less than 24 months ago, so it is not yet considered outdated.',
                },
                {
                  feedback: {},
                  value: '',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Projects Not Changing',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'These add-ons are managed by AWS, but you are responsible for upgrading them. Chkk helps you upgrade these add-ons by providing next versions, breaking change analysis, upgrade considerations, Helm/RBAC/CRD diffs, and pre/postflight checks.',
            title: '',
            type: 'banner',
          },
          {
            column_definitions: [
              {
                title: 'Name',
              },
              {
                title: 'Namespace(s)',
              },
              {
                title: 'Current',
              },
              {
                title: 'Upgrade',
              },
              {
                info_text:
                  'Suggested versions do not go through Preverification. Request an Upgrade Templates for Preverified Version Recommendations. Learn more: https://docs.chkk.io/features/upgrade-preverification#upgrade-preverification',
                title: 'Suggested',
              },
              {
                info_text:
                  'Will the current remain compatible with the next Kubernetes version after the cluster is upgraded?',
                title: 'K8s Compatibility',
              },
              {
                info_text:
                  'Is the current version supported by its upstream community, cloud or vendor?',
                title: 'Supported',
              },
              {
                info_text: 'Is the current version younger than 2 years?',
                title: 'Age \u003c 2yr',
              },
              {
                info_text:
                  'Use the feedback buttons to indicate whether you agree or disagree with this upgrade suggestion.',
                render_in: {
                  cli: false,
                  markdown: false,
                  web: true,
                },
                title: 'Give Feedback',
              },
              {
                render_in: {
                  cli: false,
                  markdown: false,
                  web: true,
                },
                title: 'Actions',
              },
            ],
            data: [
              [
                {
                  value: 'Amazon VPC CNI',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.20.1',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '1.20.5',
                },
                {
                  icon: {
                    tooltip:
                      'Version 1.20.1 is not certified for Kubernetes 1.32 on EKS according to AWS documentation.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_404d077e-3259-417b-9ce8-04aa1459fa16',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
              [
                {
                  value: 'Kube Proxy',
                },
                {
                  value: 'kube-system',
                },
                {
                  value: '1.31.13',
                },
                {
                  badges: [
                    {
                      text: 'Required',
                      variant: 'warning',
                    },
                  ],
                  value: '',
                },
                {
                  value: '1.32.0',
                },
                {
                  icon: {
                    tooltip:
                      'EKS requires the kube-proxy minor version to match the cluster minor; 1.31.x will not run on a 1.32 cluster.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    tooltip:
                      'Kubernetes only supports the last three minors; 1.31 no longer receives fixes, so this kube-proxy build is end-of-life.',
                    variant: 'error',
                  },
                  value: '',
                },
                {
                  icon: {
                    variant: 'success',
                  },
                  value: '',
                },
                {
                  feedback: {},
                  value: '',
                },
                {
                  actions: [
                    {
                      action_params: {
                        project_id: 'proj_143085db-4ed1-46da-ad99-0e79868d44ca',
                      },
                      action_type: 'request.upgrade.template',
                      icon: 'FeatherPlus',
                      tooltip:
                        'Request an Upgrade Template to help with upgrading this project',
                      value: 'Request Upgrade Template',
                    },
                  ],
                  value: '',
                },
              ],
            ],
            type: 'table',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Projects Managed by Provider',
        owner: 'chkk',
        status: 'active',
        step_number: 3,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Breaking Changes \u0026 Advisories',
    stage_number: 3,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get Upgrade Advisories for every component (worker nodes, OS, Add-ons, Projects) on your upgrade path.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Upgrade Advisories',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get all the changes that require your attention during the upgrade.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Breaking Changes',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Helm, CRD, RBAC Changes',
    stage_number: 4,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get side-by-side diffs of current vs. target CustomResourceDefinitions and Custom Resources, including schema updates.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'CRD Diff',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get exact additions and removals in ClusterRoles, Roles, and Bindings introduced by the upgrade.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'RBAC Changes',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get full diffs of Helm chart values, template files, Kustomize overlays, and raw manifests.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Package Changes for Helm, Kustomize, Raw Manifests',
        owner: 'chkk',
        status: 'active',
        step_number: 3,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },

  {
    allowed_action_types: [],
    created: 1765460982622,
    icon: 'FeatherChevronDown',
    name: 'Preflight/Postflight Checks',
    stage_number: 5,
    status: 'active',
    steps: [
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get automated and guided preflight checks run before the upgrade to verify health and rollback safety for every Add-on version, Application Service version, control plane and nodes.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Preflight Checks',
        owner: 'chkk',
        status: 'active',
        step_number: 1,
        updated: 1765460982622,
      },
      {
        allowed_action_types: [],
        comments: {},
        content_blocks: [
          {
            description:
              'Request an Upgrade Template to get automated and guided postflight checks run after the upgrade to verify health and rollback safety for every Add-on version, Application Service version, control plane and nodes.',
            title: '',
            type: 'banner',
          },
        ],
        created: 1765460982622,
        icon: 'FeatherChevronRight',
        name: 'Postflight Checks',
        owner: 'chkk',
        status: 'active',
        step_number: 2,
        updated: 1765460982622,
      },
    ],
    updated: 1765460982622,
  },
];
